import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser'
import { tap } from 'rxjs/operators';
import { SelectItemModel } from 'src/app/models/select-item';
import { GeoRegionService } from 'src/app/service/geo-region.service';
import { QuoteService } from 'src/app/service/quote.service';
import { AgentInvitationRequestModel } from 'src/app/service/web-api-client';

@Component({
  selector: 'about-us',
  templateUrl: 'about-us.component.html',
  styleUrls: ['about-us.component.css'],
})
export class AboutUsComponent implements OnInit, AfterViewInit{
  screenWidth: number;
  private observer!: IntersectionObserver;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const logo = entry.target.querySelector('.big-logo');
          const lady = entry.target.querySelector('.beneficios-lady');
          const fourBoxSection = entry.target.querySelector('.fourBoxSection');
          const beneficiosContainer = entry.target.querySelector('.beneficios-container');

          if (logo) logo.classList.add('animate');
          if (lady) lady.classList.add('animate');
          if (fourBoxSection) fourBoxSection.classList.add('animate');
          if (beneficiosContainer) beneficiosContainer.classList.add('animate');

          this.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    // Observe sections
    const sections = document.querySelectorAll('.beneficios-blue-assist, .beneficios-lady-container, .fourBoxSectionContainer');
    sections.forEach(section => this.observer.observe(section));
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // Prevent memory leaks
    }
  }

  joinUsForm: FormGroup;

  countries: SelectItemModel[];
  private _isBusy: boolean = false;
  emailSendingStatus: number = 0;
  
  constructor(
    private cdr: ChangeDetectorRef,
    private title: Title, 
    private meta: Meta, 
    private renderer: Renderer2, 
    private el: ElementRef,
    private geoRegionService: GeoRegionService,
    private fb: FormBuilder,
    private quoteService: QuoteService) {

    this.title.setTitle('AboutUs - Blue Assist')
    this.meta.addTags([
      {
        property: 'og:title',
        content: 'AboutUs - Blue Assist',
      },
    ]);

    this.createForm();
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges(); // Detect changes manually
    });
  }

  ngOnInit(): void {    
    this.countries = this.geoRegionService.getCountries();
    this.emailSendingStatus = 0;


  }
  
  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      const headerOffset = 50; // Adjust this value to match your fixed header height
      
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;
      
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }

  createForm(): void {
    this.joinUsForm = this.fb.group({
      agentName: ['', Validators.required ],
      agentEmail: ['', Validators.required ],
      agentCountry: ['', Validators.required ],
      agentPhone: ['', Validators.required]
    });
  }

  get canContinue(): boolean {
    return this.joinUsForm.valid && this.validateEmail(this.joinUsForm.controls.agentEmail.value) && this._isBusy != true && this.emailSendingStatus == 0;
  }

  private validateEmail(email: string): boolean {
    let res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(email);
  }

  sendInvitationEmail(): void {
    if(this._isBusy) {
      return;
    }
    this._isBusy = true;
    this.emailSendingStatus = 1;
    
    const request = new AgentInvitationRequestModel({
      fullName: this.joinUsForm.controls.agentName.value,
      email: this.joinUsForm.controls.agentEmail.value,
      country: this.joinUsForm.controls.agentCountry.value,
      phone: this.joinUsForm.controls.agentPhone.value
    });

    const self = this;
    this.quoteService.sendAgentInvitationEmail$(request)
      .pipe(
        //take(1),
        tap(success => {
          console.log('sending Email result: ', success);
          self._isBusy = false;
          self.emailSendingStatus = success
            ? 2
            : 3;
        })
      ).subscribe();
  }

  
}
